import React from 'react';
import { Star, Gamepad2, Trophy, CheckCircle2, Play, ListPlus, Heart } from 'lucide-react';

const StatsCards = ({ stats, games }) => {
  const platinum = games.filter(game => game.platinado).length;
  const backlog = games.filter(game => game.status === 'backlog').length;
  const items = [
    { label:'Na coleção', value:stats.total, icon:Gamepad2, color:'text-white', bg:'bg-white/[0.06]' },
    { label:'Finalizados', value:stats.completed, icon:CheckCircle2, color:'text-emerald-300', bg:'bg-emerald-400/10' },
    { label:'Jogando', value:stats.playing, icon:Play, color:'text-sky-300', bg:'bg-sky-400/10' },
    { label:'Nota média', value:stats.avgRating, icon:Star, color:'text-amber-300', bg:'bg-amber-400/10' },
    { label:'Platinados', value:platinum, icon:Trophy, color:'text-lime-300', bg:'bg-lime-400/10' },
    { label:'Favoritos', value:stats.favorites || 0, icon:Heart, color:'text-pink-300', bg:'bg-pink-400/10' },
    { label:'No backlog', value:backlog, icon:ListPlus, color:'text-violet-300', bg:'bg-violet-400/10' }
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-7 gap-3">
      {items.map(({ label, value, icon:Icon, color, bg }) => (
        <div key={label} className="retro-stat surface p-4 sm:p-5 hover:border-white/[0.14] transition">
          <div className={`w-9 h-9 rounded-xl grid place-items-center ${bg} ${color} mb-4`}><Icon className="w-4 h-4" /></div>
          <div className={`retro-number font-extrabold ${color}`}>{value}</div>
          <div className="retro-text text-[#8db5d1] text-base sm:text-lg font-semibold mt-3 leading-none">{label}</div>
        </div>
      ))}
    </div>
  );
};
export default StatsCards;
